import { FC } from "react";

import { IconProps } from "./IconProps";

export const SecondHand: FC<IconProps> = ({
  className,
  size = 16,
  color = "currentColor",
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M12 4V2L8 6L12 10V8C15.31 8 18 10.69 18 14C18 15.01 17.75 15.97 17.3 16.8L18.76 18.26C19.54 17.03 20 15.57 20 14C20 9.58 16.42 6 12 6V4Z"
      fill={color}
    />
    <path
      d="M12 20V22L16 18L12 14V16C8.69 16 6 13.31 6 10C6 8.99 6.25 8.03 6.7 7.2L5.24 5.74C4.46 6.97 4 8.43 4 10C4 14.42 7.58 18 12 18V20Z"
      fill={color}
    />
  </svg>
);
